<template>
  <div>
    <Button @click="showSelectCourse=true" type="primary">新增推荐</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="`/api/recommendDetail/${this.id}`"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="detail_id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onSet(row)">{{row.is_top==1?"取消置顶":"置顶"}}</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      width="800"
      scrollable
    >
      <CourseSelect ref="course" :status="1"></CourseSelect>
    </Modal>
  </div>
</template>
<script>
import * as enums from "@/utils/enums";
import CourseSelect from "@/components/GridSelect/CourseSelect";
export default {
  name: "MobileRecomment",
  components: {
    CourseSelect
  },
  data() {
    return {
      id: this.$route.query.id,
      tableColumns: [
        { title: "课程名称", key: "name", align: "center", minWidth: 160 },
        {
          title: "课程类型",
          key: "course_type_name",
          align: "center",
          minWidth: 160
        },
        {
          title: "创建人",
          key: "creator_name",
          align: "center",
          minWidth: 160
        },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 160,
          fixed: "right"
        }
      ],
      course_type_name: enums.CouseType.getOptions(),
      showSelectCourse: false
    };
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        (i.course_type_name = enums.CouseType.getValue(i.course_type)),
          (i.created_at = this.$pub.timestampToTime(i.created_at));
      });
    },
    onSet(row) {
      this.$http.put("/api/recommendTop/" + row.detail_id).then(() => {
        this.$Message.success("成功");
        this.search();
      });
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      if (!list || list.length == 0) {
        return;
      }
      let ids = "";
      list.forEach((item, index) => {
        if (index == list.length - 1) {
          ids += item.id;
        } else {
          ids += item.id + ",";
        }
      });
      this.$http
        .post("/api/recommendDetail", {
          recommend_channel_id: this.id,
          id: ids
        })
        .then(() => {
          this.$refs.course.recoverSelectedItems([]);
          this.$Message.success("添加成功!");
          this.search();
        });
    },
    search() {
      this.$refs.grid.searchRefresh();
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除该推荐吗？",
        onOk: () => {
          this.$http
            .delete("/api/recommendDetail/" + row.detail_id)
            .then(() => {
              this.$Message.success("删除成功!");
              this.search();
            });
        }
      });
    }
  }
};
</script>




